import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaInstagram, FaFacebookF, FaTiktok, FaYoutube } from "react-icons/fa";

export default function Header() {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);
  const [aboutMobileOpen, setAboutMobileOpen] = useState(false);
  const aboutRef = useRef(null);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  useEffect(() => {
    setOpen(false);
    setAboutOpen(false);
    setAboutMobileOpen(false);
    document.body.style.overflow = "";
  }, [location.pathname]);

  useEffect(() => {
    const onDown = (e) => {
      if (!aboutRef.current) return;
      if (!aboutRef.current.contains(e.target)) setAboutOpen(false);
    };

    const onKey = (e) => {
      if (e.key === "Escape") {
        setAboutOpen(false);
        setAboutMobileOpen(false);
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);

    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, []);

  const closeAll = () => {
    setOpen(false);
    setAboutOpen(false);
    setAboutMobileOpen(false);
    document.body.style.overflow = "";
  };

  const AboutMenuLinks = ({ onClick, className = "" }) => (
    <div className={className}>
      <Link className="navMenu__link" to="/about" onClick={onClick}>
        About Us
      </Link>
      <Link className="navMenu__link" to="/learn" onClick={onClick}>
        Learn
      </Link>
      
    </div>
  );

  const NavLinks = ({ onClick }) => (
    <>
      <Link className="nav__link" to="/clubs" onClick={onClick}>
        Clubs
      </Link>

      <Link className="nav__link" to="/vehicles" onClick={onClick}>
        Vehicles
      </Link>

      <Link className="nav__link" to="/platinum" onClick={onClick}>
        Platinum
      </Link>

      <a
        className="nav__link"
        href="https://thepowergarage.ca"
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
      >
        Partners
      </a>

      <div className="nav__dropdown" ref={aboutRef}>
        <button
          type="button"
          className={`nav__link nav__link--drop ${aboutOpen ? "is-open" : ""}`}
          aria-haspopup="menu"
          aria-expanded={aboutOpen}
          onClick={() => setAboutOpen((v) => !v)}
        >
          About <span className="nav__caret" aria-hidden="true">▼</span>
        </button>

        {aboutOpen && (
          <div className="navMenu" role="menu" aria-label="About menu">
            <AboutMenuLinks
              onClick={() => {
                setAboutOpen(false);
                onClick?.();
              }}
            />
          </div>
        )}
      </div>

      <Link className="nav__link" to="/founding-members" onClick={onClick}>
        Founding Members
      </Link>
    </>
  );

  const SocialIcons = ({ className = "", onClick }) => (
    <div className={`social ${className}`}>
      <a
        className="social__link"
        href="https://www.instagram.com/try.play.go/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
        onClick={onClick}
      >
        <FaInstagram />
      </a>

      <a
        className="social__link"
        href="https://www.facebook.com/profile.php?id=61576519182565"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Facebook"
        onClick={onClick}
      >
        <FaFacebookF />
      </a>

      <a
        className="social__link"
        href="https://www.tiktok.com/@tryplaygo"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="TikTok"
        onClick={onClick}
      >
        <FaTiktok />
      </a>

      <a
        className="social__link"
        href="https://www.youtube.com/@tryplaygo"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="YouTube"
        onClick={onClick}
      >
        <FaYoutube />
      </a>
    </div>
  );

  return (
    <header className="header">
      <div className="container header__inner">
        <div className="header__actions header__actions--mobile">
          <a className="btn btn--primary" href="tel:5199305637" onClick={closeAll}>
            Call Now
          </a>
        </div>

        <Link className="brand" to="/" aria-label="Home" onClick={closeAll}>
          <img src="/images/logo.png" alt="Recreation Memberships" className="brand__logo" />
        </Link>

        <nav className="nav nav--desktop" aria-label="Primary navigation">
          <NavLinks onClick={closeAll} />
        </nav>

        <div className="header__actions header__actions--desktop">
          <SocialIcons className="social--desktop" />
          <a className="btn btn--primary" href="tel:5199305637">
            <span className="call--desktop">519-930-5637</span>
            <span className="call--mobile">Call Now</span>
          </a>
        </div>

        <button
          type="button"
          className="navToggle"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          onClick={() => {
            setOpen((v) => !v);
            setAboutMobileOpen(false);
          }}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {open && (
        <div className="mobileNav">
          <nav className="mobileNav__inner" aria-label="Mobile navigation">
            <Link className="mobileNav__link" to="/clubs" onClick={closeAll}>
              Clubs
            </Link>
            <Link className="mobileNav__link" to="/vehicles" onClick={closeAll}>
              Vehicles
            </Link>
            <Link className="mobileNav__link" to="/platinum" onClick={closeAll}>
              Platinum
            </Link>

            <a
              className="mobileNav__link"
              href="https://thepowergarage.ca"
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeAll}
            >
              Partners
            </a>

            <button
              type="button"
              className={`mobileNav__link mobileNav__toggle ${aboutMobileOpen ? "is-open" : ""}`}
              aria-expanded={aboutMobileOpen}
              onClick={() => setAboutMobileOpen((v) => !v)}
            >
              About <span className="mobileNav__caret" aria-hidden="true">▼</span>
            </button>

            {aboutMobileOpen && (
              <div className="mobileNav__submenu" aria-label="About submenu">
                <Link className="mobileNav__sublink" to="/about" onClick={closeAll}>
                  About Us
                </Link>
                <Link className="mobileNav__sublink" to="/learn" onClick={closeAll}>
                  Learn
                </Link>
            
              </div>
            )}

            <Link className="mobileNav__link" to="/founding-members" onClick={closeAll}>
              Founding Members
            </Link>

            <SocialIcons className="social--mobile" onClick={closeAll} />
          </nav>
        </div>
      )}
    </header>
  );
}